import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
	HomeOutlined,
	UnorderedListOutlined,
	SettingOutlined,
	CalendarOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Sider } = Layout;

const LeaveManageNavigation = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [menuItems, setMenuItems] = useState([]);

	useEffect(() => {
		const items = [
			{
				key: "/utils/leave/view-applications",
				icon: <UnorderedListOutlined />,
				label: "신청 관리",
			},
			{
				key: "/utils/leave/application-status",
				icon: <CalendarOutlined />,
				label: "신청 현황",
			},
			{
				key: "/utils/leave/manage-balance",
				icon: <SettingOutlined />,
				label: "남은 월차 개수 관리",
			},
		];

		setMenuItems(items);
	}, []);

	const handleMenuClick = ({ key }) => {
		navigate(key);
	};

	const getSelectedKey = () => {
		const path =
			(location.pathname || "/").replace(/\/+$/, "") || "/";
		const menuItem = menuItems.find((item) => item.key === path);
		if (menuItem) {
			return menuItem.key;
		}
		if (path.startsWith("/utils/leave/view-applications")) {
			return "/utils/leave/view-applications";
		}
		if (path.startsWith("/utils/leave/application-status")) {
			return "/utils/leave/application-status";
		}
		if (path.startsWith("/utils/leave/manage-balance")) {
			return "/utils/leave/manage-balance";
		}
		return "/utils/apply-for-leave";
	};

	return (
		<Sider
			width={250}
			className="member-navigation__sider"
			breakpoint="lg"
			collapsedWidth="0">
			<div className="member-navigation__logo">
				<HomeOutlined />
				<span>교직원 출결 관리</span>
			</div>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={[getSelectedKey()]}
				items={menuItems}
				onClick={handleMenuClick}
				className="member-navigation__menu"
			/>
		</Sider>
	);
};

export default LeaveManageNavigation;
